import { Typography } from '@mui/material';
import { toast } from 'react-toastify';

import { regularTextColor, titleTextColor } from 'assets/styles/_palette';

export const successNotify = (title: string, description: string) =>
	toast.success(
		<div>
			<Typography fontWeight="700" color={titleTextColor}>
				{title}
			</Typography>
			<Typography color={regularTextColor}>{description}</Typography>
		</div>,
		{
			autoClose: 3000,
			position: 'top-right',
			hideProgressBar: true,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			theme: 'light',
			style: {
				borderLeft: '8px solid #01C860',
			},
		}
	);

export const infoNotify = (title: string, description: string) =>
	toast.info(
		<div>
			<Typography fontWeight="700" color={titleTextColor}>
				{title}
			</Typography>
			<Typography color={regularTextColor}>{description}</Typography>
		</div>,
		{
			autoClose: 3000,
			position: 'top-right',
			hideProgressBar: true,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			theme: 'light',
			style: {
				borderLeft: '8px solid #4786FF',
			},
		}
	);

export const errorNotify = (title: string, description: string) => {
	toast.error(
		<div>
			<Typography fontWeight="700" color={titleTextColor}>
				{title}
			</Typography>
			<Typography color={regularTextColor}>{description}</Typography>
		</div>,
		{
			autoClose: 3000,
			hideProgressBar: true,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			theme: 'light',
			style: {
				borderLeft: '8px solid #dc3545',
				width: 'fit-content',
			},
		}
	);
};
